import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  Select,
  Option,
  Textarea
} from "@material-tailwind/react";
import { useDispatch } from "react-redux";
import {
  registerLeaderProfileFUHSD,
  updateLeaderProfileFUHSD
} from "../../store/actions/user.action";
import { courses } from "../../components/Transformation/Transformations"
import { useTranslation } from "react-i18next";
import { ELDLevelInfoTooltip } from "../General/InfoTooltip";

export function AddLeaderProfileFUHSD(props) {
  const { t } = useTranslation();
  const [teaching_language, setTeaching_language] = useState("");
  const [student_level_expected_by_teacher, setStudent_level_expected_by_teacher] =
    useState("");
  const [introduction, setIntroduction] = useState("");
  const [interestedTopic, setInterestedTopic] = useState("");
  const [school, setSchool] = useState("");
  const [whyBecomeTutor, setWhyBecomeTutor] = useState("");
  const [teacherEldLevel, setTeacherEldLevel] = useState("");
  const [teacherForApplicantReference, setTeacherForApplicantReference] = useState("");

  const token = localStorage.getItem("token");
  const mail = localStorage.getItem("mail");

  const dispatch = useDispatch();

  useEffect(() => {
    setTeaching_language(props.teaching_language || "");
    setStudent_level_expected_by_teacher(String(props.teaching_language_skill_level) || "");
    setIntroduction(props.introduction || "");
    setInterestedTopic(props.interested_topics || "");
    setSchool(props.school || "");
    setWhyBecomeTutor(props.whyBecomeTutor || "");
    setTeacherEldLevel(props.teacherEldLevel || "");
    setTeacherForApplicantReference(props.teacherForApplicantReference || "");
  }, [props]);

  const sendData = () => {
    if (
      !teaching_language ||
      !student_level_expected_by_teacher ||
      !interestedTopic ||
      !introduction ||
      !school ||
      !whyBecomeTutor  ||
      !teacherForApplicantReference||
      !teacherEldLevel
    ) {
      toast.warn(t("generic.enter_all"), {
        position: "bottom-right"
      });
      return;
    }

    if (interestedTopic.length > 198) {
      toast.warn(t("leader_profile.interested_topics_too_long"), {
        position: "bottom-right",
      });
      return;
    }

    if (whyBecomeTutor.length > 500) {
      toast.warn("Your response for 'Why do you want to become a tutor' is too long. Please limit it to 500 characters.", {
        position: "bottom-right",
      });
      return;
    }

    props.close();
    if (props.isEditing) {
      dispatch(
        registerLeaderProfileFUHSD({
          token,
          mail,
          teaching_language,
          teaching_language_skill_level: student_level_expected_by_teacher,
          interestedTopic,
          introduction,
          school,
          whyBecomeTutor,
          teacherForApplicantReference,
          teacherEldLevel
        })
      );
    } else {
      dispatch(
        updateLeaderProfileFUHSD({
          teaching_language,
          teaching_language_skill_level: student_level_expected_by_teacher,
          introduction,
          interested_topics: interestedTopic,
          school,
          whyBecomeTutor,
          teacherForApplicantReference,
          teacherEldLevel,
          index: props.index,
          token,
          mail
        })
      );
    }
  };

  return (
    <>
      <Dialog open={props.open} className="max-h-[90vh]">
        <DialogHeader className="flex justify-center">
          {props.isEditing
            ? t("become_a_leader.add_course")
            : t("become_a_leader.update_course")} (FUHSD)
        </DialogHeader>
        <DialogBody className="overflow-y-auto max-h-[60vh] md:max-h-[65vh]">
          <div className="flex flex-col gap-8">
            <Select
              variant="outlined"
              label={t("become_a_leader.teaching_lang")}
              className="h-[40px] text-2xl"
              value={teaching_language}
              onChange={(val) => setTeaching_language(val)}
            >
              {courses.map((course) => (
                <Option key={course.value} value={course.value}>
                  {t(course.label)}
                </Option>
              ))}
            </Select>
            <div>
              <div className="flex items-center gap-2 mb-2">
                <label className="text-sm font-medium text-gray-700">
                  {t("become_a_leader.student_level_expected_by_teacher")}
                </label>
                <ELDLevelInfoTooltip />
              </div>
              <Select
                variant="outlined"
                className="h-[40px] text-2xl"
                value={student_level_expected_by_teacher}
                onChange={(val) => setStudent_level_expected_by_teacher(val)}
              >
                <Option value={"7"}>ELD1 and above</Option>
                <Option value={"8"}>ELD2 and above</Option>
                <Option value={"9"}>ELD3 and above</Option>
                <Option value={"10"}>Above ELD3</Option>
              </Select>
            </div>

            <Textarea
              label={t("become_a_leader.course_intro")}
              value={introduction}
              onChange={(e) => setIntroduction(e.target.value)}
            />
            <Textarea
              label={t("become_a_leader.topics")}
              value={interestedTopic}
              onChange={(e) => setInterestedTopic(e.target.value)}
            />

            <div>
              <label className="text-sm font-medium text-gray-700 mb-2 block">
                1. Which school are you in?
              </label>
              <Select
                variant="outlined"
                className="h-[40px] text-2xl"
                value={school}
                onChange={(val) => setSchool(val)}
              >
                <Option value="CupertinoHighSchool">Cupertino High School</Option>
                <Option value="FremontHighSchool">Fremont High School</Option>
                <Option value="HomesteadHighSchool">Homestead High School</Option>
                <Option value="LynbrookHighSchool">Lynbrook High School</Option>
                <Option value="MontaVistaHighSchool">Monta Vista High School</Option>
              </Select>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">
                2. Why do you want to become a tutor for English Language Development(ELD) program?
              </label>
              <textarea
                value={whyBecomeTutor}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 500) {
                    setWhyBecomeTutor(value);
                  }
                }}
                className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 min-h-[100px]"
                placeholder="Please explain your motivation for becoming an ELD tutor"
                maxLength={500}
              />
              <div className="mt-1 text-xs text-gray-500 text-right">
                {whyBecomeTutor.length}/500 characters
              </div>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-2">
                <label className="text-sm font-medium text-gray-700">
                  3. What is your ELD level?
                </label>
                <ELDLevelInfoTooltip />
              </div>
              <Select
                variant="outlined"
                className="h-[40px] text-2xl"
                value={teacherEldLevel}
                onChange={(val) => setTeacherEldLevel(val)}
              >
                <Option value="ELD1">ELD1</Option>
                <Option value="ELD2">ELD2</Option>
                <Option value="ELD3">ELD3</Option>
                <Option value="Close to Native Speaker">Close to Native Speaker</Option>
                <Option value="Native Speaker">Native Speaker</Option>
              </Select>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">
                4. Teacher Reference (Name and/or Email)
              </label>
              <input
                type="text"
                value={teacherForApplicantReference}
                onChange={(e) => setTeacherForApplicantReference(e.target.value)}
                className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter teacher name and/or email for reference"
              />
            </div>
            
            <div className="flex justify-end gap-4 pt-4">
              <Button
                variant="gradient"
                color="red"
                className="mr-1 ml-1"
                onClick={props.close}
              >
                <span>{t("generic.cancel")}</span>
              </Button>
              <Button variant="gradient" color="purple" onClick={sendData}>
                <span>
                  {props.isEditing ? t("generic.add") : t("generic.update")}
                </span>
              </Button>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
}

